import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';

import { getRawFilter } from './getRawFilter';
import { IDecisionListFilterRaw } from '../interfaces/IDecisionListFilterRaw';
import { IDecisionListFilterParams } from '../interfaces/IDecisionListFilterParams';

export const getRequestFilterData = (
  searchValue: string,
  filter?: IDecisionListFilterParams,
): IDecisionListFilterParams | null => {
  const isFilterOn = !!getStorageItem(StorageNamesEnum.DECISION_FILTER_ON);

  if (filter) {
    return searchValue ? { ...filter, searchString: searchValue } : { ...filter };
  }
  const rawFilter: IDecisionListFilterRaw = getRawFilter();

  if (!rawFilter) {
    return null;
  }

  let requestData: IDecisionListFilterParams | null = null;

  if (isFilterOn) {
    requestData = searchValue ? { ...rawFilter, searchString: searchValue } : { ...rawFilter };
  } else {
    requestData = searchValue ? { searchString: searchValue } : {};
  }

  return requestData;
};
